import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/pwa";
import { initColorTheme } from "@/hooks/useColorTheme";
import { initLogoTint } from "@/hooks/useLogoTint";

// Apply persisted color theme synchronously to avoid flash of default coral
initColorTheme();
initLogoTint();

registerServiceWorker();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
